module.exports = __webpack_public_path__ + "static/media/ch.cf554778.svg";